import { useMemo } from 'react'
import {Flame} from 'lucide-react'

const MESES = [
  "JANEIRO", "FEVEREIRO", "MARÇO", "ABRIL", "MAIO", "JUNHO",
  "JULHO", "AGOSTO", "SETEMBRO", "OUTUBRO", "NOVEMBRO", "DEZEMBRO"
]

function getVagasDoDia() {
  const now = new Date()
  const seed = now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate()
  const hash = ((seed * 9301 + 49297) % 233280) / 233280
  return Math.floor(hash * 19) + 12 // entre 12 e 30
}

export default function StickyTopBar() {
  const mesAtual = useMemo(() => MESES[new Date().getMonth()], [])
  const vagas = useMemo(() => getVagasDoDia(), [])

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-red-600 via-red-500 to-red-600 text-white py-1.5 px-3 md:py-2.5 md:px-4 text-center shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-1.5 md:gap-2 text-xs md:text-base font-semibold tracking-wide">
        <Flame className="w-3.5 h-3.5 md:w-5 md:h-5 animate-pulse flex-shrink-0" />
        <span className="hidden sm:inline">LOTE DE {mesAtual}: <span className="underline decoration-2">{vagas} vagas restantes</span> para acompanhamento ao vivo</span>
        <span className="sm:hidden">🔥 <span className="underline decoration-2">{vagas} vagas restantes</span></span>
        <Flame className="w-4 h-4 md:w-5 md:h-5 animate-pulse flex-shrink-0 hidden sm:block" />
        <a
          href="https://checkout.ewpass.com.br/subscribe/ewpass-semestral"
          target="_blank"
          rel="noopener noreferrer"
          className="ml-1.5 md:ml-3 bg-white text-red-600 font-bold text-[10px] md:text-sm px-2 py-0.5 md:px-3 md:py-1 rounded-full hover:bg-red-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          👉 Quero minha vaga
        </a>
      </div>
    </div>
  )
}
